import React from 'react';

import DescriptionIcon from '@mui/icons-material/Description';
import { useTheme } from '@mui/material/styles';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { TEMPLATE_TYPES } from 'common/constants';

import { getDocumentItemSx } from '../helpers';

import SideMenuCard from './SideMenuCard';
const DataSheetsCard = ({
    datasheets,
    handleClickDocumentItem,
    isDisabled,
    selectedDocumentId,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    if (isEmpty(datasheets)) return null;
    return (
        <SideMenuCard
            icon={<DescriptionIcon sx={{ color: 'primary.main' }} />}
            title={t('Data sheet', { count: 2 })}
        >
            <List disablePadding>
                {datasheets.map((datasheet) => (
                    <ListItem
                        disabled={
                            isDisabled || datasheet.id === selectedDocumentId
                        }
                        disablePadding
                        key={`datasheet-${datasheet.id}`}
                        selected={datasheet.id === selectedDocumentId}
                        sx={getDocumentItemSx(theme)}
                    >
                        <ListItemButton
                            onClick={() => {
                                if (isDisabled) return;
                                handleClickDocumentItem({
                                    archive: datasheet.data_sheet,
                                    id: datasheet.id,
                                    name: datasheet.name,
                                    type: TEMPLATE_TYPES.PDF_TYPE,
                                });
                            }}
                            sx={{ borderRadius: '8px' }}
                        >
                            <ListItemText primary={datasheet.name} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </SideMenuCard>
    );
};

DataSheetsCard.propTypes = {
    datasheets: PropTypes.array,
    handleClickDocumentItem: PropTypes.func,
    isDisabled: PropTypes.bool,
    selectedDocumentId: PropTypes.string,
};

export default DataSheetsCard;
